'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modified version of RFC 3986 Appendix B
var validateUrlUnencoded = (0, _regexSupplant2.default)('^' + // Full URL
'(?:' + '([^:/?#]+):\\/\\/' + // $1 Scheme
')?' + '([^/?#]*)' + // $2 Authority
'([^?#]*)' + // $3 Path
'(?:' + '\\?([^#]*)' + // $4 Query
')?' + '(?:' + '#(.*)' + // $5 Fragment
')?$', 'i'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validateUrlUnencoded;
module.exports = exports['default'];